import { render, staticRenderFns } from "./ProjectSearchResultHeader.vue?vue&type=template&id=1b4bfc0e"
import script from "./ProjectSearchResultHeader.vue?vue&type=script&lang=js"
export * from "./ProjectSearchResultHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports